<template>
    <div class="join join-horizontal items-center">
        <button
            type="button"
            class="btn btn-square disabled:border-border border-border disabled:!bg-base-300 bg-base-100 btn-outline join-item !border-e-1 !me-[-1px] z-[1]"
            :disabled="qty === min || inputDisabled"
            :aria-label="$t('product.qtySelector.decrease')"
            @click="decrement()"
        >
            <MiscIcon name="minus" size="sm" />
        </button>
        <div class="join-item p-0 border-none">
            <label for="quantity-selector" class="sr-only">{{ $t('product.qtySelector.label') }}</label>
            <input
                id="quantity-selector"
                v-model="qty"
                type="number"
                :min="min"
                :max="max"
                :class="inputClasses"
                :disabled="inputDisabled"
            >
        </div>
        <button
            type="button"
            class="btn btn-square btn-outline join-item border-s-1 !ms-[-2px] border-border bg-base-100 disabled:border-border disabled:!border-r-[1px] disabled:bg-base-300"
            :disabled="qty === max || inputDisabled"
            :aria-label="$t('product.qtySelector.increase')"
            @click="increment()"
        >
            <MiscIcon name="plus" size="sm" />
        </button>
    </div>
</template>

<script setup lang="ts">
const qty = defineModel<number>('qty', { required: true })
const props = defineProps<{
    min: number,
    max: number,
    inputDisabled: boolean
}>()

// Browser-specific styling for number input centering
const isFirefox = ref(false)

onMounted(() => {
    // Firefox doesn't need padding, Chrome/Safari do
    isFirefox.value = /Firefox/.test(navigator.userAgent)
})

const inputClasses = computed(() => {
    const base = 'input number-no-spinner w-[44px] text-center disabled:bg-base-300 bg-base-200 border-y-border border-x-none rounded-none -z-[1]'
    // Firefox doesn't need padding, Chrome and Safari do
    const browserSpecific = isFirefox.value ? 'px-0' : 'pl-2'
    return `${base} ${browserSpecific}`
})

function decrement () {
    if (qty.value > props.min) {
        qty.value--
    }
}

function increment () {
    if (qty.value < props.max) {
        qty.value++
    }
}
</script>
